import React from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../CustomModal/CustomModal";
import { translationConstants } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { invoiceActions } from "../../../redux/actions/invoice.action";

const ViewInvoices = ({ isShowModal, setShowModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const invoiceData = useSelector((state) => state.InvoiceReducer.invoiceData);

  const closeModalHandler = () => {
    setShowModal(false);
    dispatch(invoiceActions.setInvoiceDataNull());
  };

  return (
    <CustomModal
      size="md"
      scrollable={true}
      customClass="view-user-modal"
      show={isShowModal}
      setShow={closeModalHandler}
      closeOnOutsideClick={true}
    >
      <section>
        <p className="fs-5 fw-bold">
          {t(translationConstants.PAYMENT_INVOICE_LINKS)}
        </p>
        <p className="horizentalLine" />
        <h6 className="fw-bold">{t(translationConstants.INVOICE_LINK)}</h6>
        {invoiceData?.invoiceLink ? (
          <a
            href={invoiceData?.invoiceLink}
            target="_blank"
            rel="noreferrer"
            className="font-14 underline center-card-view-detail-link approved-color"
          >
            <span className="text-break">
              {t(translationConstants.CLICK_HERE_TO_DOWNLOAD)}
            </span>
          </a>
        ) : (
          <h6 className="font-14">
            {t(translationConstants.NO_INVOICE_LINK_AVAILABLE)}
          </h6>
        )}
        <h6 className="pt-3 fw-bold">
          {t(translationConstants.CREDIT_NOTE_LINK)}
        </h6>
        {invoiceData?.creditNoteLink ? (
          <a
            href={invoiceData?.creditNoteLink}
            target="_blank"
            rel="noreferrer"
            className="font-14 underline center-card-view-detail-link approved-color"
          >
            <span className="text-break">
              {t(translationConstants.CLICK_HERE_TO_DOWNLOAD)}
            </span>
          </a>
        ) : (
          <h6 className="font-14">
            {t(translationConstants.NO_CREDIT_NOTE_LINK_AVAILABLE)}
          </h6>
        )}
      </section>
    </CustomModal>
  );
};

export default ViewInvoices;
